export default {

  // nav bar
  home: 'Aρχική',
  activities: 'Εκκρεμότητες',
  myprofile: 'Προφίλ',
  settings: 'Ρυθμίσεις',

  // home
  AN: 'Ανακοινώσεις',
  DB: 'Ταμπλό',
  LM: 'Διαχείριση Αδειών',
  ML: 'Προσωπικές Άδειες',
  MLL: 'Λίστα',
  MSC: 'Ημερολόγιο',
  NL: 'Νέα Αίτηση',
  EL: 'Αίτηση',
  UP: 'Επερχόμενες',
  TUPD: 'Επερχόμενες άδειες oμάδας',
  TSC: 'Πρόγραμμα Ομάδας',
  MS: 'Μηνιαίο Πρόγραμμα',
  BL: 'Προσωπικό Υπόλοιπο',
  TB: 'Υπόλοιπο Ομάδας',
  RM: 'Υπόλοιπο',
  RMSub: 'Το υπόλοιπο της ετήσιας άδειάς σας',
  leaveApprovals: 'προς  Έγκριση',
  NLE: 'Αίτηση για Υπάλληλο',
  pending: 'Εκκρεμείς',
  request: 'Αιτήσεις',
  TS: "Φύλλα Χρόνου",
  MT: "Τα Φύλλα Χρόνου Μου",
  TSA: "Έγκριση Φύλλου Χρόνου",
  CD: 'Στοιχεία Πελάτη',
  CP: 'Έργα Πελάτη',

  // HR Admin
  hrAdmin: "Ανθρώπινο Δυναμικό",
  hrAdminDashboard: 'Ταμπλό',
  hrAdminCompany: 'Εταιρεία',
  hrAdminEmployees: 'Υπάλληλοι',
  RecruitmentCandidates: 'Υποψήφιοι',
  RecruitmentVacancies: 'Κενές Θέσεις',
  hrAdminReports: 'Αναφορές',
  hrAdminTrainings: 'Εκπαιδεύσεις',
  hrAdminClients: 'Πελάτες',
  hrUtilities: 'Υπηρεσίες',

  // Company Tab
  newCompany: 'Νέα Εταιρεία',
  editCompany: 'Επεξεργασία Εταιρείας',
  branches: 'Υποκαταστήματα',
  locations: 'Τοποθεσίες',
  buildingFloors: 'Όροφοι',
  functions: 'Λειτουργίες',
  functionsServiceLinesDepts: 'Λειτουργίες - Γραμμές Εξυπηρέτησης - Τμήματα',
  serviceLines: 'Γραμμές Εξυπηρέτησης',
  departments: 'Τμήματα',
  emplContext: 'Πλαίσιο εργαζομένων',
  leaveSchemes: 'Σχέδια άδειας',
  staffLevel: 'Επίπεδο Προσωπικού',
  jobTitles: 'Τίτλοι Εργασίας',
  leaveTypes: 'Τύποι άδειας',
  workflows: 'Ροή εργασίας',
  emplAuth: 'Employee Authorizations',
  authorizations: 'Εξουσιοδοτήσεις',
  salarySchemes: 'Σχέδια Μισθών',
  rates: 'Τυπικές Τιμές Χρέωσης',
  employeeRates: 'Τιμές Χρέωσης',
  massUpload: 'Μαζικό ανέβασμα δεδομένων',

  // Employees Tab
  selectEmployee: 'Επιλογή Υπαλλήλου',
  newEmployee: 'Νέος Υπάλληλος',
  editEmployee: 'Επεξεργασία Υπαλλήλου',
  leaveAnalysis: 'Ανάλυση Αδειών',
  workflows: 'Ροές Εργασίας',
  reportsTo: 'Προϊστάμενοι',
  salaryReviews: 'Αξιολογήσεις Μισθού',
  academicQual: 'Ακαδημαϊκά Προσόντα',
  additionalQual: 'Επιπλέον προσόντα',
  specialDoc: 'Ειδικά Έγγραφα',
  exitProcess: 'Διαδικασία Εξόδου',
  advSettings: 'Προχωρημένες Ρυθμίσεις',

  // to-do
  LAA: 'Αιτήσεις προς  Έγκριση',

  // Training Tab
  trnCategories: 'Κατηγορίες',
  trnSubjects: 'Θέματα',
  training: 'Εκπαιδεύσεις',
  trnDetails: 'Λεπτομέρειες Εκπαίδευσης',
  courseDetails: 'Λεπτομέρειες Μαθήματος',
  participants: 'Συμμετέχοντες',
  trnEvaluationForm: 'Φόρμα Αξιολόγησης',
  prerequisites: 'Προαπαιτούμενα',
  trnMaterial: 'Εκπαιδευτικό Υλικό',
  trnLAndDMethod: 'Μέθοδος Μάθησης και Ανάπτυξης',
  trnLAndDNeed: 'Ανάγκη Μάθησης και Ανάπτυξης',
  MyTRN: 'Οι Εκπαιδεύσεις Μου',

  //Events
  EV: 'Εκδηλώσεις',
  MR: 'Οι Εγγραφές Μου',
  EF: 'Διευκολυντές',

  // Survey
  SR: 'Επισκόπηση',
  CS: 'Δημιουργία Επισκόπησης',
  ES: 'Τροποποίηση Επισκόπησης',

  // profile
  personalInfo: 'Προσωπικά Στοιχεία',
  emergencyInfo: 'Προσωπικές Επαφές',
  documents: ' Έγγραφα',
  preferences: 'Προτιμήσεις',
  mydocuments: 'Τα Έγγραφα μου',


  // CURRENTLY NOT USED
  LA: 'Αναλυτική Άδεια',
  MLS: 'Μηνιαίο Πρόγραμμα Αδειών',
  TLS: 'Πρόγραμμα Ομάδας',
  TLB: 'Αναλυτική Άδεια Ομάδας',
  HIST: 'History',
  AM: 'Assessment Management',
  SM: 'Διαχείριση Επισκοπήσεων',
  AM: 'Διαχείριση Αξιολογήσεων',

  //Analytics
  employees: "Εργαζόμενοι",
  leaves: "Άδειες",
  groupBy: "Ομαδοποίηση Εργαζομένων",
  averageAge: "Μέση Ηλικία",
  averageWorkingYears: "Μέσος Όρος Ετών Εργασίας",
  genderBreakdown: "Κατανομή Φύλου",
  ageRanges: "Εργαζόμενοι ανά Ηλικιακή Ομάδα",
  tenureRanges: "Διάρκεια Υπηρεσίας Ενεργού Προσωπικού (Έτη)",
  female: "Γυναίκες",
  male: "Άνδρες",
  attritionRate: "Ποσοστό Αποχωρήσεων",
  leavers: "Αποχωρήσαντες",
  avgHeadcount: "Μέσος Αριθμός Προσωπικού",
  employmentTypes: "Τύποι Απασχόλησης",
  qualificationTypes: "Προσόντα",
  leaveRequestsPerMonth: "Εγκεκριμένες Άδειες ανά Μήνα",
  leaveRequestsHeatmap: "Μηνιαίος Θερμικός Χάρτης",
  tapDayForDetails: "Πατήστε μια ημέρα για λεπτομέρειες",

  filter: 'ΕΦΑΡΜΟΓΗ',
  clear: 'ΕΚΚΑΘΑΡΙΣΗ',
  sort: 'Ταξινόμηση',
  cancel: 'Ακύρωση',
  shiftSchedulePeriods: 'Περίοδοι Προγράμματος Βαρδιών',
};
